
import { useState, useEffect } from 'react';

export type BestTimeToVisitOption = {
  key: string;
  label: string;
  description: string;
  months: string[];
};

export const BEST_TIME_OPTIONS: BestTimeToVisitOption[] = [
  {
    key: 'winter',
    label: 'Winter',
    description: '',
    months: ['december', 'january', 'february']
  },
  {
    key: 'spring',
    label: 'Spring',
    description: '',
    months: ['march', 'april', 'may']
  },
  {
    key: 'summer',
    label: 'Summer',
    description: '',
    months: ['june', 'july', 'august']
  },
  {
    key: 'fall',
    label: 'Fall',
    description: '',
    months: ['september', 'october', 'november']
  }
];

export const useFilterOptions = () => {
  return {
    bestTimeOptions: BEST_TIME_OPTIONS
  };
};
